module.exports = __webpack_public_path__ + "img/39.5cc8a971.png";